window.snack = (message) => {
  vm.$children[0].snackbar(message);
};



// WEBPACK FOOTER //
// ./src/js/helper.js